import { $FixMe } from '@eventbrite/ts-utils';
import classNames from 'classnames';
import find from 'lodash/find';
import includes from 'lodash/includes';
import {
    BUCKET_WRAPPER_WITH_DECORATION_CLASSES,
    CATEGORY_TEMPLATE,
    COLLECTION_TEMPLATE,
    DECORATIVE_IMAGE_PLACEMENT_MAP,
    EDITORIAL_ARTICLES_BUCKET_KEY,
    EVENT_TIME_OPTIONS_TEMPLATE,
    NEARBY_CITIES_TEMPLATE,
    NON_EVENT_BUCKET_SPACING_CLASSES,
    ORGANIZER_FOLLOW_TEMPLATE,
    SHARED_BUCKET_SPACING_CLASSES,
    TRENDING_SEARCHES_TEMPLATE,
} from '../../../../constants';

const NON_EVENT_BUCKETS = [
    CATEGORY_TEMPLATE,
    NEARBY_CITIES_TEMPLATE,
    TRENDING_SEARCHES_TEMPLATE,
    ORGANIZER_FOLLOW_TEMPLATE,
    EVENT_TIME_OPTIONS_TEMPLATE,
];
/*
 Returns the decorativeImagePlacement matching the selector and adds it to an array to prevent duplicates
*/
const _getDecorativeImagePlacement = (
    key: string,
    usedDecorativeImages: Array<string | string[]>,
) => {
    const decorativeImage = find(
        DECORATIVE_IMAGE_PLACEMENT_MAP,
        (decorativeImageData) => {
            const { selectors } = decorativeImageData;

            let isKeyMappedInPlacementMap;

            if (!includes(usedDecorativeImages, selectors)) {
                isKeyMappedInPlacementMap = includes(selectors, key);

                if (isKeyMappedInPlacementMap) {
                    usedDecorativeImages.push(selectors);
                }
            }

            return isKeyMappedInPlacementMap;
        },
    );

    return decorativeImage || undefined;
};

export const getDecorativeImage = (
    decorativeImages: { [key: string]: string },
    key: string,
    usedImages: Array<string | string[]>,
) => {
    let decorativeImage;

    const decorationPlacement: $FixMe = _getDecorativeImagePlacement(
        key,
        usedImages,
    );

    if (decorationPlacement) {
        decorativeImage = decorativeImages[decorationPlacement.urlSelector];
    }

    return { decorationPlacement, decorativeImage };
};

export const getBucketClasses = (
    key: string,
    decorativeImage: string,
    template: string,
) => {
    // Only the articles and collections section should have a gray background
    const shouldHaveBackground =
        key === EDITORIAL_ARTICLES_BUCKET_KEY || key === COLLECTION_TEMPLATE;

    const containerClasses = classNames({
        'eds-bg-color--grey-100': shouldHaveBackground,
    });

    let spacingClasses = SHARED_BUCKET_SPACING_CLASSES;

    if (includes(NON_EVENT_BUCKETS, template)) {
        spacingClasses = NON_EVENT_BUCKET_SPACING_CLASSES;
    }

    const bucketWrapperClasses = classNames(spacingClasses, {
        [BUCKET_WRAPPER_WITH_DECORATION_CLASSES]: decorativeImage,
        'collection-bucket-top-spacing': key === COLLECTION_TEMPLATE,
    });

    return { containerClasses, bucketWrapperClasses };
};
